export const ColorPickerColors = ["#4E67C8", "#5ECCF3", "#A7EA52", "#5DCEAF", "#FF8021", "#F14124", "#283A7F", "#0E8FBC"];

export const dateFormat = "DD/MM/YYYY";
export const dateFormatShort = "DD/MM/YY"
export const dateTimeFormat = "DD/MM/YYYY HH:mm";
export const dateFormatDotted = "DD.MM.YY";
export const dateFormatSpaces = "DD MMM YY";
export const dateTimeFormatSpaced = "DD MMM YYYY HH:mm"
export const timeFormat = "HH:mm";

export const maxCustomerNameLength = 25;

export const RestrictionTypes = {
    OpenRestrictionType: 5,
    ClosedRestrictionType: 1,
    ClosedForArrivalRestrictionType: 2,
    ClosedForDepartureRestrictionType: 3,
    ClosedForArrivalAndDepartureRestrictionType: 4,
    ClosedAndClosedForDepartureRestrictionType: 6
}

export const Languages = {
    Arabic: { ID: 1, code: "ar", locale: "ar" },
    Chinese: { ID: 2, code: "ch", locale: "zh" },
    English: { ID: 3, code: "en", locale: "en-US" },
    French: { ID: 4, code: "fr", locale: "fr" },
    Greek: { ID: 5, code: "gk", locale: "el" },
    German: { ID: 6, code: "gr", locale: "de" },
    Hebrew: { ID: 7, code: "he", locale: "he-IL" },
    Italian: { ID: 8, code: "it", locale: "it" },
    Japanese: { ID: 9, code: "ja", locale: "ja" },
    Netherlands: { ID: 10, code: "nl", locale: "nl" },
    Portuguese: { ID: 11, code: "pr", locale: "pt" },
    Russian: { ID: 12, code: "ru", locale: "ru" },
    Spanish: { ID: 13, code: "sp", locale: "es" },
    Serbian: { ID: 14, code: "sr", locale: "sr" },
    Swedish: { ID: 15, code: "sw", locale: "sv" },
};

export const EntityTypes = [
    "None",
    "Reservation",
    "Bon",
    "Guest",
    "Hotel",
    "Amenity",
    "Room",
    "VipCode",
    "Activity",
    "Club",
    "Template",
    "Addon",
    "RoomType",
    "Report",
    "General",
    "Customer",
    "GuestVoice",
    "Wings",
    "ReservationSources",
    "MarketSegments",
    "Agent",
    "Company",
    "Nationality",
    "User",
    "GuestGroup",
    "HousekeepingStatuses",
    "MaintenanceStatuses",
    "GuestValueType",
    "Package",
    "Group",
    "ApartmentOwner",
    "Workstations",
    "HotelDateparameter",
    "Printers",
    "DefaultPrinters",
    "Diningroom",
    "Roles",
    "Units",
    "HotelChain",
    "NightAudit",
    "GuestSearch",
    "GuestProfile",
    "LoyaltyPrograms",
    "GuestPreferences",
    "Customers",
    "CustomerGroups",
    "ScheduleMails",
    "GuestValueTypes",
    "Nationality",
    "ReviewSources",
    "GuestTitles",
    "Folio",
    "CurrencyExchange",
    "HotelCurrency",
    "TransactionCodeGroupCategories",
    "TransactionCodeGroups",
    "TransactionRevenueDepartments",
    "TransactionCodes",
    "HotelTaxes",
    "PaymentArrangements",
    "Budgets",
    "TaxTypes",
    "Taxes",
    "HotelCreditCardTypes",
    "Currency",
    "Housekeeping",
    "RoomPlannedMaintenance",
    "HotelWings",
    "Ameneties",
    "RoomLocations",
    "Rates",
    "CalendarEvent",
    "Note",
    "Tapechart",
    "FolioIndex",
    "Automation",
    "Documentseries",
    "ApartmentOwners",
    "Automation",
    "ReservationCategory"
]

export const EntityType = {
    Reservation: 1,
    Guest: 3,
    Room: 6,
    Addon: 11,
    RoomType: 12,
    Customer: 15,
    Wings: 17,
    MarketSegment: 19,
    AGENT: 20,
    COMPANY: 21,
    Package: 28,
    ReservationGroup: 29,
    ApartmentOwner: 30,
    Folio: 53
};

export const Actions = {
    EditCalendar: 157,
    ViewHotels: 75
}

export const MenuActions = {
    save: "main-menu-save",
    toggle: "main-menu-toggle",
    note: "main-menu-note"
}

export const TemplateType = {
    Confirmation: 1,
    PartyConfirmation: 22,
    GroupConfirmation: 25,
    TermsAndConditions: 27,
    PrivacyPolicy: 28,
}


export const UserDefaultHomePage = {
    HomePage: 0,
    Dashboard: 1,
    Calendar: 2,
    LivePage: 3,
}

export const ReservationAmountOverrideType = {
    Proportional: 1,
    AmountByNight: 2,
    AmountByTotal: 3,
    Free: 4
}

//HS-69601: must match PMS ReservationCategoryType
export const ReservationCategoryType = {
    All: 0,
    System: 1,
    User: 2,
}


export const TaxAuthorityResultCodeTitles = {
    0: "Eligible",
    1: "NotEligible",
    2: "NotFoundOrInvalid",
    3: "LeftTheCountry",
    100: "Error"
}

export const HotelFeatureCodes = {
    ManageAllReservationStatuses: 1,
    SelfieFinance: 2,
    SelfieCreditCardInterface: 3,
    SelfieRevenueManagement: 4,
    SelfieHouseKeeping: 5,
    SelfieApartmentOwners: 6,
    Sms: 7,
    Optima2BasicReports: 8,
    CustomerCommissions: 9,
    ChannelManagerReporting: 10,
    GroupReservations: 11,
    ShowSettingsView: 12,
    CheckTaxExemption: 13,
    TaxAuthority: 16,
    ClubMember: 17
}

export const GuestAccountType = {
    Normal: 1,
    Red: 2,
    Black: 3
}

export const ReservationTypes = {
    Individuals: 0,
    GroupMaster: 1,
    GroupMembers: 2,
}

export const RateCategory = {
    FullRateBaseRate: 1,
    DayUse: 2,
    BasicDealDerivedRate: 3,
    LastMinuteEarlyBookers: 4,
    FreeNights: 5,
    GroupRate: 6,
    CorporateRate: 7,
    ExtraAddon: 8,
    AgentPromotion: 9,
    ChannelDiscount: 10
}

export const RateType =
{
    PerRoom: 1,
    PerPerson: 2,
    PerCombination: 3,
    Villa: 4
}

export const DateRange = {
    CheckIn: "CheckInDateRange",
    CheckOut: "CheckOutDateRange",
}

export const OperationsEnum = { ADD: 'ADD', REMOVE: 'REMOVE', CHANGE: 'CHANGE' };

/*List of available key-press events can be found here (add to this enum as needed): 
https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values*/
export const KeyboardKeys = {
    Enter: 'Enter',
    Tab: 'Tab',
    ArrowDown: 'ArrowDown',
    ArrowLeft: 'ArrowLeft',
    ArrowRight: 'ArrowRight',
    ArrowUp: 'ArrowUp',
}

/*List of available key-press events can be found here (add to this enum as needed): 
https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent*/
export const keyEventListeners = {
    keyDown: 'keydown',
    keyUp: 'keyup',
}

export const PaymentTypesEnum = {
    Cash: 1,
    CreditCards: 2,
    BankTransfers: 3,
    Voucher: 4,
    CityLedger: 5,
    Check: 6
}

export const NoteStatusEnum = {
    Cancel: 0,
    Open: 1,
    Completed: 2,
};

export const SystemTagsEnum = {
    GuestPending: 1,
    CustomerPending: 2,
    TaxAuthorityPending: 3

}

export const ConnectedRoomTypeEnum = {
    0: 'All',
    1: 'Adjoined',
    2: 'Connected',
    3: 'Connected/Adjoined'
};
export const TaxAuthorityStatus = {
    432: 'Customer VAT Number Is Incorrect',
    433: 'Invoice type Is Incorrect',
    434: 'Invoice Date Is More Than Two Weeks Old',
    435: 'Invoice Date Is In The Future',
    436: 'VAT Amount Is Greater Than The Calculated VAT',
    437: 'VAT Amount Is Greater Than 0',
    438: 'Invoices Amount As Not The Same As Actual Invoices Amount',
    439: 'Invoices Amount Is 0',
    440: 'Requesting VAT Number Is Different From VAT Number In Voices List',
    441: 'Action 4 Requires Invoice Type 305',
    520: 'Refresh Token Is Not Found',
    500: 'Application Error',
    200: 'Approved'
}

/*export const statusesReasonTypes = {
    [ReservationStatusesEnums.Cancelled]: 'Cancellation',
    [ReservationStatusesEnums.Deleted]: 'Deletion',
}*/

export const ReservationStatuses =
{
    1: 'Reserved',
    2: 'Checked In',
    3: 'Checked Out',
    4: 'No Show',
    5: 'Cancelled',
    6: 'Arrived',
    7: 'Deleted',
    8: 'Released',
    9: 'Tentative',
    10: 'Option',
    11: 'Waiting List'
}
export const InvoiceStatuses = {
    1: 'Open',
    2: 'Pending',
    3: 'Closed',
    4: 'TechnicalErrors'
};
export const InvoiceStatusesEnum = {
    Open: 1,
    Pending: 2,
    Closed: 3,
    TechnicalErrors: 4
};